import type { Language } from '@/types'

/**
 * Languages
 */
export const langDefault: Language = 'fr'
export const langAvailable = ['fr', 'nl', 'en'] as const
